module.exports = __webpack_public_path__ + "static/media/muestra.025b5914.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/muestra.jpg
// module id = 188
// module chunks = 0